import { Component, OnDestroy, OnInit } from '@angular/core';
import { NewPlaylistService } from '@core/services/new-playlist.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { NewPlayListInitialState } from '@core/interfaces/new-playlist.interface';
import { MatDialog } from '@angular/material/dialog';
import { DeletePlaylistDialog } from '@app/channel/dialogs/delete-dialog/delete-playlist.dialog';
import { UserInfoService } from '@core/services/user-info.service';
import { CurrentUserData } from '@core/interfaces';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-playlist-channel',
    templateUrl: './playlist-channel.component.html',
    styleUrls: ['playlist-channel.component.scss']
})

export class PlaylistChannelComponent implements OnInit, OnDestroy {
    public dataSourcePlayListState$: Observable<NewPlayListInitialState> | undefined;
    public createPostGroup: FormGroup | unknown;
    public authChannelId: any;
    public paramsChannelId: any;

    constructor(
        private _fb: FormBuilder,
        private _dialog: MatDialog,
        private _newPlaylistService: NewPlaylistService,
        private _userInfoService: UserInfoService,
        private route: ActivatedRoute
    ) {
        this.dataSourcePlayListState$ = this._newPlaylistService.newPlaylistState$.state$;
    }

    ngOnInit() {
        this._newPlaylistService.getAllPlayList();
        this._currentUserData();
        this.route.params
            .subscribe(params => {
                this.paramsChannelId = params.id;
            });
    }


    public openConfirmDialog(id: number) {
        this._dialog.open(DeletePlaylistDialog, {
            height: 'auto',
            width: 'auto',
            data: {
                id
            }
        });
    }

    private _currentUserData() {
        this._userInfoService._userInfo
            .subscribe((data: CurrentUserData) => {
                this.authChannelId = data.channel.id;
            });
    }


    ngOnDestroy() {
    }
}
